import React, { useState, useEffect } from 'react';

const ScrollButtons = () => {
  const [showUp, setShowUp] = useState(false);
  const [showDown, setShowDown] = useState(true);

  const getScrollRoot = () => document.scrollingElement || document.documentElement || document.body;

  // Update visibility based on current scroll position
  const updateVisibility = () => {
    const root = getScrollRoot();
    const scrollTop = root.scrollTop || window.scrollY || window.pageYOffset || 0;
    const maxScroll = root.scrollHeight - root.clientHeight;

    setShowUp(scrollTop > 300);
    setShowDown(scrollTop < maxScroll - 300);
  };

  const smoothScrollTo = (top) => {
    const root = getScrollRoot();
    try {
      root.scrollTo({ top, behavior: 'smooth' });
    } catch (_) {
      // Fallback
      root.scrollTop = top;
    }
  };

  const scrollToTop = () => smoothScrollTo(0);
  const scrollToBottom = () => {
    const root = getScrollRoot();
    smoothScrollTo(root.scrollHeight);
  };

  useEffect(() => {
    updateVisibility(); // initialize
    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility);
    return () => {
      window.removeEventListener('scroll', updateVisibility);
      window.removeEventListener('resize', updateVisibility);
    };
  }, []);

  return (
    <div className="scroll-buttons" aria-live="polite">
      {showUp && (
        <button onClick={scrollToTop} className="scroll-button up" aria-label="Scroll to top" title="Scroll to top">
          {/* Fallback icon */}
          <span aria-hidden>▲</span>
        </button>
      )}
      {showDown && (
        <button onClick={scrollToBottom} className="scroll-button down" aria-label="Scroll to bottom" title="Scroll to bottom">
          {/* Fallback icon */}
          <span aria-hidden>▼</span>
        </button>
      )}
    </div>
  );
};

export default ScrollButtons;
